import React from "react"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import { Link } from "gatsby"

export default ({ data }) => {
  return (
    <Container fluid>
      <Row>
        <Col sm={12}>
          <h4 className="text-center">{data.title}</h4>
          <ul>
            <li>{data.li1}</li>
            <ul>
              <li>{data.li2}</li>
              <li>{data.li3}</li>
              <li>{data.li4}</li>
            </ul>
            <li>{data.li5}</li>
            <br/>
            <h4>Modus operandi:</h4>
            <li>{data.li8}</li>
            <li>{data.li9_1} <Link to="/contact"><u>{data.li9_2}</u></Link></li>
            <ul>
              <li>{data.li10}</li>
              <li>{data.li11}</li>
              <li>{data.li12}</li>
            </ul>
            <li>{data.li13}</li>
            <li>{data.li14}</li>
            <li>{data.li15}</li>
            <li>{data.li16}</li>
          </ul>
        </Col>
      </Row>
    </Container>
  )
}
